import React from "react";
import { useDispatch } from "react-redux";
import { minimizeInsightsTab, switchMainTab } from "../../../../actions/insightsRecommendationActions";
import { useHistory } from "react-router-dom";
import { setActiveModule } from "../../../../actions/sideBarActions";
import Scrollbars from "react-custom-scrollbars";
import { ReactComponent as MinimizeIcon } from "../../../../assets/svg/minimize-icon.svg";

const Help = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (tab) => {
        dispatch(switchMainTab(tab));
    };

    const handleRedirect = () => {
        localStorage.setItem("activeModule", "Listening");
        dispatch(setActiveModule("Listening"));
        history.push("/data/query-builder");
    };
    const minimizeTab = () => {
        dispatch(minimizeInsightsTab(true));
    };
    return (
        <>
            <div className="insights__home__page">
                <div className="top__section">
                    <div className="minimize__icon" onClick={minimizeTab}>
                        <MinimizeIcon />
                    </div>
                    <div className="heading__block no__margin">
                        <div className="left">
                            <div className="insights__heading genie">
                                Insights Genie <span className="top__content">Beta</span>
                            </div>
                        </div>
                        {/* <div className="right">
                            <SettingsIcon onClick={toggleSettings} className={`settings__icon ${isSettingsActive ? "active" : ""}`} />
                        </div> */}
                    </div>
                    <div className="lower__section">
                        <p className="help_section">Generative AI-powered insights from your own data!</p>
                    </div>
                </div>
                <div className="main__content__wrapper">
                    <Scrollbars>
                        <div className="help-section">
                            <span className="one">
                                We have made it really easy for you to analyze the data. Radarr Insights uses GPT-3 to analyze the data for your topics and
                                provides you with meaningful insights so that you do not have to go through millions of conversation.
                            </span>
                            <span className="two">How to get started ?</span>
                            <span className="three">
                                <span>i)</span>
                                <span>
                                    It is very simple to get started. Make sure you have created queries to get started. If you have not, &nbsp;
                                    <span className="hyper__Link__query" onClick={handleRedirect}>
                                        click here
                                    </span>
                                    &nbsp; to go to query builder and create query.
                                </span>
                            </span>
                            <span className="four">
                                <span>(ii)</span>
                                <span>
                                    You can select your brand and also your competitor brand. To start just click on the settings icon, select your brand and if
                                    you want you can select your competitor brand too.
                                </span>
                            </span>
                            <span className="five">
                                <span>(iii)</span>
                                <span>
                                    Now the magic will start and we will analyze the conversations of your brand and competitor and will provide you with
                                    meaningful insights.
                                </span>
                            </span>
                        </div>

                        <button className="help-button" onClick={() => handleClick("home")}>
                            Get Started
                        </button>
                    </Scrollbars>
                </div>
            </div>
        </>
    );
};

export default Help;
